import script from "./PaperDelete.vue?vue&type=script&setup=true&lang=js"
export * from "./PaperDelete.vue?vue&type=script&setup=true&lang=js"

import "./PaperDelete.vue?vue&type=style&index=0&id=0d8b441e&lang=scss"

const __exports__ = script;

export default __exports__